/*
**************************** 
홈페이지 비번 찾기(인증번호전송) 
*****************************
*/

import axios from "axios";
import { useEffect, useState } from "react";
import FindResultEndPass from "./FindResultEndPass";

export default function FindResultPass() {
    const [otpConfirm, setOtpConfirm] = useState({ withData: "" });
    const [loginIdArr, setLoginIdArr] = useState([]);

    useEffect(() => {
        resetFunc();

        return () => {
            resetFunc();
        }
    }, []);

    const resetFunc = function () {
        let copyOtpConfirm = { ...otpConfirm };
        copyOtpConfirm.withData = "";
        setOtpConfirm(copyOtpConfirm);
    };

    const setFunc = (e) => {
        let copyOtpConfirm = { ...otpConfirm };
        copyOtpConfirm.withData = e.target.value;
        setOtpConfirm(copyOtpConfirm);
    };

    const requestOtpConfirm = async function () {

        const otp_confirm = otpConfirm.withData;
        if (otp_confirm === undefined || otp_confirm === "") {
            alert("가입한 이메일 또는 휴대폰을 확인 하세요")
            return;
        }

        resetFunc();
        const reqSql = "/api/users/otp-confirm";
        const params = { otp_confirm };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.status === 200) {
                let copyData = [...loginIdArr];
                copyData = res.data;
                setLoginIdArr(copyData);

                window.findREPass();

            } else {
                if (res.status === 204) {
                    alert("등록된 아이디가 없습니다.");
                } else if (res.status === 205) {
                    alert("인증번호 에러");

                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }

    return (
        <div>
            <div>
                <div className="modal fade" id="findResultPass" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">인증</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                    resetFunc();
                                }}></button>
                            </div>
                            <div className="modal-body">
                                <div className="sign-up">
                                    <form>
                                        <div className="form-group text-start">
                                            <label className="form-label mt-4 small">가입한 이메일로 인증번호를 전송하였습니다.</label>
                                        </div>
                                        <div className="form-group text-start">
                                            <input type="number" className="form-control" placeholder="인증번호를 입력해 주세요." name="otp_confirm" onChange={(e) => {
                                                setFunc(e);
                                            }} value={otpConfirm.withData} ></input>
                                        </div>
                                        <div className="form-group mt-2 row p-2">
                                            <button type="button" className="btn btn-lg btn-primary mt-3" data-bs-dismiss="modal" onClick={() => {
                                                requestOtpConfirm();
                                            }}>확인</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FindResultEndPass loginIdArrData={loginIdArr}></FindResultEndPass>
        </div>
    )
} 